export const grading = {
  'settings.tab.grading': 'الدرجات',
  'grading.title': 'الدرجات والامتحانات',
  'grading.subtitle': 'إدخال الدرجات، كشوف النتائج، والنشر لأولياء الأمور',
  'grading.setup': 'إعداد خطط الدرجات',
  'grading.studentTab': 'الدرجات',
  'grading.view.entry': 'إدخال الدرجات',
  'grading.view.results': 'النتائج',
  'grading.view.publish': 'النشر',
  'grading.class': 'الصف',
  'grading.subject': 'المادة',
  'grading.exam': 'الامتحان',
  'grading.student': 'الطالب',
  'grading.published': 'منشور',
  'grading.secondRound': 'الدور الثاني',
  'grading.print': 'طباعة',
  'grading.kind.EXAM': 'امتحان',
  'grading.kind.AVERAGE': 'معدل',
  'grading.status.ABSENT': 'غائب',
  'grading.status.EXCUSED': 'معفى',
  'grading.outcome.PASSED': 'ناجح',
  'grading.outcome.PASSED_SECOND_ROUND': 'ناجح (دور ثانٍ)',
  'grading.outcome.SECOND_ROUND': 'مكمل',
  'grading.outcome.FAILED': 'راسب',
  'grading.outcome.INCOMPLETE': 'غير مكتمل',
  'grading.rounding.UP': 'جبر الكسر لصالح الطالب',
  'grading.rounding.HALF_UP': 'تقريب لأقرب عدد صحيح',
  'grading.rounding.NONE': 'بدون تقريب (منزلتان عشريتان)',
  'grading.rounding.UP.hint': '٧٣٫٥ تصبح ٧٤، و٧٣٫٢ تصبح ٧٤ أيضاً.',
  'grading.rounding.HALF_UP.hint': '٧٣٫٥ تصبح ٧٤، و٧٣٫٢ تصبح ٧٣.',
  'grading.rounding.NONE.hint': 'تبقى المعدلات بكسورها، مثل ٧٣٫٥.',

  'grading.plans.title': 'خطط الدرجات',
  'grading.plans.hint': 'لكل مرحلة طريقة احتساب: الامتحانات، والمعدلات وأوزانها، ودرجة النجاح والتقديرات. السنة الدراسية {year}.',
  'grading.plans.add': 'خطة جديدة',
  'grading.plans.edit': 'تعديل',
  'grading.plans.delete': 'حذف',
  'grading.plans.deleteTitle': 'حذف خطة «{name}»؟',
  'grading.plans.deleteBody': 'لم تُدخل أي درجات بهذه الخطة بعد، فيمكن حذفها.',
  'grading.plans.deleted': 'حُذفت الخطة.',
  'grading.plans.empty': 'لا توجد خطط درجات لهذه السنة',
  'grading.plans.emptyBody': 'ابدأ من قالب جاهز لبلدك ثم عدّله إن لزم.',
  'grading.plans.outOf': 'من {max}',
  'grading.plans.pass': 'النجاح {pass}',
  'grading.plans.exams': 'الامتحانات: {n}',
  'grading.plans.secondRound': 'بدور ثانٍ',
  'grading.plans.noSecondRound': 'بلا دور ثانٍ',
  'grading.plans.noGrades': 'لم تُربط بأي مرحلة بعد',
  'grading.plans.marks': '{n} درجة مُدخلة',
  'grading.plans.withoutPlan': 'مراحل بلا خطة درجات: {grades}.',

  'grading.templates.title': 'خطة جديدة',
  'grading.templates.hint': 'اختر قالباً قريباً من نظامكم، ويمكن تعديل كل شيء بعدها.',
  'grading.templates.for': 'يناسب: {grades}',
  'grading.templates.blank': 'خطة فارغة',
  'grading.templates.confirm': 'القوالب مبنية على تعليمات الوزارة المعتادة. راجعوا الأوزان ودرجة النجاح مع تعليمات هذه السنة قبل إدخال الدرجات.',

  'grading.plan.newTitle': 'خطة درجات جديدة',
  'grading.plan.editTitle': 'تعديل خطة الدرجات',
  'grading.plan.name': 'اسم الخطة',
  'grading.plan.namePlaceholder': 'مثلاً: المتوسطة والإعدادية',
  'grading.plan.maxMark': 'الدرجة الكاملة',
  'grading.plan.maxMarkHint': 'تُحسب عليها المعدلات والنتيجة، مثل ١٠٠ أو ١٠.',
  'grading.plan.passMark': 'درجة النجاح',
  'grading.plan.rounding': 'تقريب المعدلات',
  'grading.plan.items': 'الامتحانات والمعدلات',
  'grading.plan.itemsHint': 'رتّبها كما تُحسب: كل معدل يُبنى مما فوقه، والبند الأخير هو النتيجة النهائية للمادة.',
  'grading.plan.itemName': 'الاسم',
  'grading.plan.outOf': 'من',
  'grading.plan.result': 'النتيجة',
  'grading.plan.removeItem': 'حذف البند',
  'grading.plan.averageOf': 'معدل لـ (والوزن):',
  'grading.plan.weight': 'الوزن',
  'grading.plan.resitHere': 'درجة الدور الثاني تحل محل هذا الامتحان',
  'grading.plan.addExam': 'امتحان',
  'grading.plan.addAverage': 'معدل',
  'grading.plan.finalExam': 'الامتحان النهائي',
  'grading.plan.secondRound': 'دور ثانٍ للراسبين',
  'grading.plan.secondRoundHint': 'من يرسب في عدد محدود من المواد يؤدي امتحاناً ثانياً فيها.',
  'grading.plan.maxFailed': 'أقصى عدد مواد للدور الثاني',
  'grading.plan.maxFailedHint': 'اتركه فارغاً إن لم يكن هناك حد.',
  'grading.plan.bands': 'التقديرات (من نسبة الدرجة الكاملة)',
  'grading.plan.bandLabel': 'التقدير',
  'grading.plan.bandFrom': 'من ٪',
  'grading.plan.addBand': 'تقدير',
  'grading.plan.removeBand': 'حذف التقدير',
  'grading.plan.grades': 'المراحل التي تتبع هذه الخطة',
  'grading.plan.gradeElsewhere': 'تتبع الآن «{plan}»؛ اختيارها ينقلها إلى هذه الخطة.',
  'grading.plan.issue.name': 'اكتب اسم الخطة.',
  'grading.plan.issue.max': 'الدرجة الكاملة عدد صحيح أكبر من صفر.',
  'grading.plan.issue.pass': 'درجة النجاح بين الصفر والدرجة الكاملة.',
  'grading.plan.issue.items': 'أضف امتحاناً واحداً على الأقل.',
  'grading.plan.issue.itemName': 'لكل امتحان ومعدل اسم.',
  'grading.plan.issue.examMax': 'لكل امتحان درجة كاملة (عدد صحيح).',
  'grading.plan.issue.parts': 'اختر ما يُبنى منه كل معدل، بأوزان أكبر من صفر.',
  'grading.plan.issue.unused': 'كل امتحان ومعدل يجب أن يدخل في النتيجة (البند الأخير).',
  'grading.plan.issue.maxFailed': 'أقصى عدد مواد للدور الثاني عدد صحيح.',
  'grading.plan.issue.bands': 'التقديرات مرتبة من الأعلى إلى الأدنى، ولكل منها اسم ونسبة بين ٠ و١٠٠.',

  'grading.entry.noClasses': 'لا توجد صفوف لك هذه السنة.',
  'grading.entry.noPlan': 'لا توجد خطة درجات لهذه المرحلة بعد.',
  'grading.entry.setUpPlan': 'إعداد خطة الدرجات',
  'grading.entry.noSubjects': 'لا توجد مواد لهذا الصف. أضفها من الإعدادات ← المواد.',
  'grading.entry.noStudents': 'لا يوجد طلاب في هذا الصف.',
  'grading.entry.noResits': 'لا يوجد راسبون في هذه المادة.',
  'grading.entry.outOf': 'من {max}',
  'grading.entry.entered': 'أُدخلت {n} من {total}',
  'grading.entry.locked': 'هذه الدرجات منشورة لأولياء الأمور، فلا يمكن تعديلها. يستطيع المدير تصحيحها.',
  'grading.entry.resitHint': 'تظهر هنا من رسب في المادة فقط. درجة الدور الثاني تحل محل الامتحان المحدد في الخطة.',
  'grading.entry.firstResult': 'النتيجة الأولى',
  'grading.entry.mark': 'الدرجة',
  'grading.entry.status': 'الحالة',
  'grading.entry.by': 'أدخلها',
  'grading.entry.saveN': 'حفظ {n}',
  'grading.entry.saved': 'حُفظت {n} درجة.',
  'grading.entry.discard': 'تراجع',
  'grading.entry.invalid': 'بعض الدرجات غير صحيحة: من ٠ إلى {max}، بمنزلتين عشريتين على الأكثر.',

  'grading.results.show': 'عرض',
  'grading.results.rank': 'التسلسل',
  'grading.results.passLine': 'النجاح {pass} من {max}. الأحمر دون درجة النجاح.',
  'grading.results.printSheet': 'طباعة الكشف',
  'grading.results.printCards': 'طباعة بطاقات الطلاب',
  'grading.results.sheetTitle': 'كشف الدرجات',

  'grading.report.title': 'بطاقة الدرجات',
  'grading.report.band': 'التقدير',
  'grading.report.average': 'المعدل',
  'grading.report.outcome': 'النتيجة',
  'grading.report.rank': 'التسلسل {rank} من {of}',
  'grading.report.secondRoundNote': 'نتيجة الدور الثاني',
  'grading.report.signTeacher': 'مربي الصف',
  'grading.report.signPrincipal': 'مدير المدرسة',
  'grading.report.noClass': 'الطالب غير مسجل في صف هذه السنة.',
  'grading.report.noPlan': 'لا توجد خطة درجات لمرحلة هذا الطالب.',

  'grading.publish.publish': 'نشر',
  'grading.publish.unpublish': 'إلغاء النشر',
  'grading.publish.notPublished': 'غير منشور',
  'grading.publish.publishedBy': 'نُشر في {date}، نشره {name}',
  'grading.publish.shownUnder': 'يظهر ضمن «{item}»',
  'grading.publish.confirmTitle': 'نشر «{item}»؟',
  'grading.publish.confirmBody': 'سيرى أولياء الأمور والطلاب هذه الدرجات وما بُنيت عليه، وتصلهم رسالة في التطبيق. لن يستطيع المدرّسون تعديلها بعد النشر.',
  'grading.publish.done': 'نُشرت الدرجات وأُرسلت الرسائل.',
  'grading.publish.hidden': 'أُلغي النشر.',
} as const;
